<template>
  <form @submit.prevent="onSubmit" class="vehicle-evaluation">
    <h2 class="title-steps-form">Evaluate your vehicle</h2>
    <base-range-selector
      v-for="(question, key, index) in questions"
      :key="key"
      :name="key"
      :label="`${index + 1}. ${question}`"
      v-model="answers[key]"
      v-validate="'required'"
      low-indicator="Poor"
      high-indicator="Excellent"
      :error-messages="errors.has(key) ? ['The question is required'] : []"
    />
    <div class="submit-form">
      <button type="submit" class="primary-button btn-small btn-primary">
        <img src="/img/icons/check.svg" alt="icon-check" />
        Submit Evaluation
      </button>
    </div>
  </form>
</template>

<script>
import { ref } from '@vue/composition-api';
import BaseRangeSelector from '@/components/base-range-selector';
import { tradeFormStateHelper } from '@/composable/tradeFormStateHelper';

export default {
  name: 'VehicleEvaluation',
  props: {
    questions: {
      type: Object,
      required: true,
    },
    initialData: {
      type: Object,
      default: function () {
        return {};
      },
    },
  },
  components: {
    BaseRangeSelector,
  },
  setup(props, { emit }) {
    const answers = ref({});
    tradeFormStateHelper(props, answers, emit);

    return { answers };
  },
  methods: {
    async validate() {
      return await this.$validator.validateAll();
    },
    async onSubmit() {
      if (await this.validate()) {
        this.$emit('submit', this.answers);
      }
    },
  },
};
</script>

<style lang="scss" scoped>
.vehicle-evaluation {
  display: flex;
  flex-direction: column;
  justify-content: center;
  align-items: center;

  .submit-form {
    border: none;
    button {
      margin: 0;
    }
  }
}
</style>
